import { Box, CircularProgress, CircularProgressLabel } from '@chakra-ui/react';

type ScoreProps = {
  value: number | string | boolean | undefined;
  withIndicator?: boolean;
  size?: string | number;
  min?: number;
  max?: number;
};

const thruthyScoreColor = (score?: boolean) => {
  if (score === true) {
    return 'red';
  }
  if (score === false) {
    return 'green';
  }

  return 'orange';
};

const numericScoreColor = (score?: number) => {
  if (score === undefined) {
    return 'gray';
  }
  if (score <= 4) {
    return 'red';
  }
  if (score > 4 && score < 7) {
    return 'orange';
  }
  if (score >= 7) {
    return 'green';
  }

  return 'orange';
};

function ScoreBadge(props: ScoreProps) {
  const { size = 8, value, withIndicator, min = 0, max = 10 } = props;

  let baseColor = 'orange';
  let numericValue = 0;
  let textValue = 'TBD';

  if (typeof value === 'number') {
    baseColor = numericScoreColor(value);
    numericValue = Math.max(min, Math.min(max, value));
    textValue = numericValue.toString();
  } else if (typeof value === 'boolean') {
    baseColor = thruthyScoreColor(value);
    textValue = value ? 'Yes' : 'No';
  } else if (typeof value === 'string') {
    baseColor = thruthyScoreColor(true);
    textValue = value;
  }

  const color = withIndicator ? `${baseColor}.400` : 'transparent';

  return (
    <Box
      borderRadius="full"
      overflow="hidden"
      bgColor={`${baseColor}.100`}
      _dark={{
        bgColor: `${baseColor}.700`,
      }}
    >
      <CircularProgress
        aria-label="Score indicator"
        min={min}
        max={max}
        m="-0.2em"
        thickness="10%"
        trackColor="transparent"
        value={numericValue}
        color={color}
        size={size}
      >
        <CircularProgressLabel
          fontWeight="medium"
          fontSize="sm"
          color={`${baseColor}.800`}
          _dark={{
            color: `${baseColor}.100`,
          }}
        >
          {textValue}
        </CircularProgressLabel>
      </CircularProgress>
    </Box>
  );
}
export default ScoreBadge;
